namespace app.documentos {

    export class OnlyofficeDirectiveApiImpl implements OnlyofficeDirectiveApi {
        
        private pluginsDispatchers: {[key: string]: PluginDispatcher} = {
            
        };

        constructor(private $scope: OnlyofficeScope, private config: DocsAPI.OnlyofficeConfig, private $q: ng.IQService) {
            config.events["onInternalMessage"] = (data) => this.onInternalMessage(data);
            if (config.editorConfig.plugins) {
                for (let plugin of config.editorConfig.plugins.pluginsData) {
                    let urlComponents = plugin.split("/");
                    let pluginName = urlComponents[urlComponents.length - 2];
                    this.pluginsDispatchers[pluginName] = new PluginDispatcher(pluginName, this.$scope, this.$q);
                }
            }
        }

        private onInternalMessage(message) {
            if (message.data.type && message.data.type.indexOf("plugin-call:") === 0) {
                let callId = PluginGatewayCallId.fromString(message.data.type);
                if (this.pluginsDispatchers[callId.getPluginName()]) {
                    let pluginDispatcher = this.pluginsDispatchers[callId.getPluginName()];
                    pluginDispatcher.onCallMessage(callId, message);
                }
            } else if (message.data.type && message.data.type.indexOf("plugin-event:") === 0) {
                let eventId = PluginGatewayEventId.fromString(message.data.type);
                if (this.pluginsDispatchers[eventId.getPluginName()]) {
                    let pluginDispatcher = this.pluginsDispatchers[eventId.getPluginName()];
                    pluginDispatcher.onEventMessage(eventId, message);
                }
            }
        }

        plugin(name: string): OnlyofficePluginApi {
            if (this.pluginsDispatchers[name]) {
                return this.pluginsDispatchers[name];
            } else {
                throw `Plugin ${name} não será carregado.`;
            }
        }

    }
    
    export class PluginDispatcher implements OnlyofficePluginApi {
        
        private pendingRequests: {[key: string]: ng.IDeferred<{}>} = {
            
        };

        private eventsCallbacks: {[key: string]: Array<(data?: {}) => void>} = {

        };
        
        constructor(private name: string, private $scope: OnlyofficeScope, private $q: ng.IQService) {
            
        }
        
        public onCallMessage(callId: PluginGatewayCallId, message) {
            if (this.pendingRequests[callId.toMethodString()]) {
                let pendingRequest = this.pendingRequests[callId.toMethodString()];
                delete this.pendingRequests[callId.toMethodString()];
                pendingRequest.resolve(message.data.data);
            }
        }

        public onEventMessage(eventId: PluginGatewayEventId, message) {
            if (this.eventsCallbacks[eventId.toEventString()]) {
                let eventCallbacks = this.eventsCallbacks[eventId.toEventString()];
                for (let eventCallback of eventCallbacks) {
                    eventCallback(message.data.data);
                }
            }
        }
        
        public call(method: string, params): ng.IPromise<{}> {
            let deferred = this.$q.defer();
            let callId = new PluginGatewayCallId(this.name, method, pseudorandomId());
            this.pendingRequests[callId.toMethodString()] = deferred;
            this.$scope.docEditor.serviceCommand(callId.toFullQualifiedString(), params);
            return deferred.promise;
        }

        public on(eventName, callbackFn: (data?: {}) => void) {
            let eventId = new PluginGatewayEventId(this.name, eventName);
            if (!this.eventsCallbacks[eventId.toEventString()]) {
                this.eventsCallbacks[eventId.toEventString()] = [];
            }
            this.eventsCallbacks[eventId.toEventString()].push(callbackFn);
            return function unsubscribe() {
                _.remove(this.eventsCallbacks[eventId.toEventString()], e => e === callbackFn);
            };
        }
        
    }

    export class PluginGatewayCallId {
        
        public static fromString(pluginGatewayCallIdStr: string): PluginGatewayCallId {
            let atComponents = pluginGatewayCallIdStr.split("@");
            let collonComponents = atComponents[0].split(":");
            
            return new PluginGatewayCallId(collonComponents[1], collonComponents[2], atComponents[1]);
        }
        
        constructor(private pluginName: string, private methodName: string, private requestId: string) {
            
        }
        
        public getPluginName() {
            return this.pluginName;
        }
        
        public toFullQualifiedString() {
            return `plugin-call:${this.pluginName}:${this.methodName}@${this.requestId}`;
        }
        
        public toMethodString() {
            return `${this.methodName}@${this.requestId}`;
        }
        
    }
    
    export class PluginGatewayEventId {
        
        public static fromString(pluginGatewayCallIdStr: string): PluginGatewayEventId {
            let collonComponents = pluginGatewayCallIdStr.split(":");
            
            return new PluginGatewayEventId(collonComponents[1], collonComponents[2]);
        }
        
        constructor(private pluginName: string, private eventName: string) {
            
        }
        
        public getPluginName() {
            return this.pluginName;
        }
        
        public toFullQualifiedString() {
            return `plugin-event:${this.pluginName}:${this.eventName}`;
        }
        
        public toEventString() {
            return `${this.eventName}`;
        }
        
    }

    function pseudorandomId() {
        return new Date().getTime().toString() + Math.floor(Math.random() * 65536); 
    }

}